import { render, staticRenderFns } from "./AffiliatesRegister.vue?vue&type=template&id=3c7af089"
import script from "./AffiliatesRegister.vue?vue&type=script&lang=js"
export * from "./AffiliatesRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports